import React from 'react';

const servicesData = [
  {
    name: 'Data Analytics',
    icon: 'fas fa-chart-line',
    description: 'Comprehensive insights and tracking to measure and improve performance'
  },
  {
    name: 'SEO Optimization',
    icon: 'fas fa-search',
    description: 'Technical and content strategies to enhance search engine visibility'
  },
  {
    name: 'Performance Tuning',
    icon: 'fas fa-tachometer-alt',
    description: 'Speed optimization and efficiency improvements for better user experience'
  },
  {
    name: 'Conversion Optimization',
    icon: 'fas fa-chart-bar',
    description: 'Strategic enhancements designed to improve engagement and conversions'
  },
  {
    name: 'Marketing Integration',
    icon: 'fas fa-bullhorn',
    description: 'Seamless connections with marketing platforms for maximum impact'
  },
  {
    name: 'Technical Development',
    icon: 'fas fa-code',
    description: 'Robust architecture and clean code built for scalability and performance'
  },
];

const Services = () => {
  return (
    <div className="section skills-container bg-white" id="services">
      <div className="container">
        <div className="row" style={{ marginBottom: '50px' }}>
          <div className="col-lg-6 col-md-12 text-wrapper">
            <h4 className="section-heading-left">OUR EXPERTISE</h4>
            <h2 className="section-subtitle-left">Data-Driven Digital Solutions</h2>
            <p>
              We design and develop websites and platforms that make a measurable difference to your online presence. 
              By blending technical precision with marketing strategy, we create digital experiences that drive traffic, engage users, and achieve tangible business goals.
            </p>
          </div>

          <div className="col-lg-6 col-md-12 d-none d-lg-flex image-wrapper">
            <img src="assets/img/illustration/9.png" alt="Data Analytics Illustration" className="skills-image" />
          </div>
        </div>

        <div className="services-grid">
          {servicesData.map((service, index) => (
            <div key={index} className="service-box">
              <div className="text-content">
                <h3 className="heading-left">{service.name}</h3>
                <p>{service.description}</p>
              </div>
              <i className={service.icon}></i>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services; 